// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_m0-0";
export var buttonContainer = "_m0-3";
export var cancelButton = "_m0-4";
export var headerSection = "_m0-6";
export var headerTitle = "_m0-9";
export var messageSideLeft = "_m0-1";
export var messageSideRight = "_m0-2";
export var orderNumberContainer = "_m0-7";
export var orderNumberLabel = "_m0-8";
export var submitButton = "_m0-5";